// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"DefaultLayout_wrapper__5AEMw"};